module.exports = __webpack_public_path__ + "media/images/lb/006-250f1af39877e9ac7c8ee29d940e96e6.svg";